import { Injector, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'locale',
})
export class LocalePipe implements PipeTransform {
  public constructor(private readonly injector: Injector) {}

  transform(value: Array<any>): any {
    if (!value || !value.length) {
      return null;
    }
    return value.filter((v) => v.locale == 'en').length
      ? value.filter((v) => v.locale == 'en')[0].name
      : value[0].name;
  }
}
